'use client'

// Network configuration
export const getCurrentNetwork = () => ({
  id: 0x4a,
  name: 'VeChain',
  token: 'VET',
}) 